import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import GLightbox from "glightbox";
import { BsLink45Deg, BsZoomIn } from "react-icons/bs";
import "glightbox/dist/css/glightbox.min.css";
import Header from "./Header";
import Hero from "./Hero";
import Footer from "./Footer";
import { useTranslation } from "react-i18next";

const projectData = {
  filters: [
    { label: "All", value: "*" },
    { label: "Remodeling", value: ".filter-remodeling" },
    { label: "Construction", value: ".filter-construction" },
    { label: "Repairs", value: ".filter-repairs" },
    { label: "Design", value: ".filter-design" }
  ],
  items: [
    {
      id: 1,
      category: "filter-remodeling",
      imgSrc: require("../assets/img/projects/key1.jpg"),
      title: "App 1",
      subtitle: "Lorem ipsum, dolor sit amet consectetur",
      gallery: "portfolio-gallery-app",
      detailsLink: "/project-details"
    },
    {
      id: 2,
      category: "filter-construction",
      imgSrc: require("../assets/img/projects/key2.jpg"),
      title: "Product 1",
      subtitle: "Lorem ipsum, dolor sit amet consectetur",
      gallery: "portfolio-gallery-product",
      detailsLink: "/project-details"
    },
    {
      id: 3,
      category: "filter-repairs",
      imgSrc: require("../assets/img/projects/key3.jpg"),
      title: "Branding 1",
      subtitle: "Lorem ipsum, dolor sit amet consectetur",
      gallery: "portfolio-gallery-branding",
      detailsLink: "/project-details"
    }
    // add additional items as needed
  ]
};
const Uberuns = () => {
  const isotopeRef = useRef(null);
  const containerRef = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    const imagesLoaded = require("imagesloaded");
    const Isotope = require("isotope-layout");

    imagesLoaded(containerRef.current, () => {
      isotopeRef.current = new Isotope(containerRef.current, {
        itemSelector: ".portfolio-item",
        layoutMode: "masonry"
      });
    });

    projectData.items.forEach(item => {
      GLightbox({ selector: `.${item.gallery}`, touchNavigation: true, loop: true });
    });

    return () => isotopeRef.current?.destroy();
  }, []);

  const handleFilterClick = filter => {
    isotopeRef.current?.arrange({ filter });
  };

  return (
    <div className="KeysHome">
      <Header />
      <main className="main">
        <Hero compact />
        <section id="projects" className="projects section">
          <div className="container section-title" data-aos="fade-up">
            <h2>{t("key-company-aboutus.title")}</h2>
            <br />
            <p>{t("key-company-aboutus.info1")}</p>
            <br />
            <p>{t("key-company-aboutus.info2")}</p>
            <br />
            <p>{t("key-company-aboutus.info3")}</p>
          </div>

          <div className="container">
            <div className="isotope-layout" data-layout="masonry">
              <div
                className="row gy-4 isotope-container"
                data-aos="fade-up"
                data-aos-delay="200"
                ref={containerRef}
              >
                {projectData.items.map(
                  ({ id, category, imgSrc, title, subtitle, gallery, detailsLink }) => (
                    <div
                      key={id}
                      className={`col-12 col-md-6 col-lg-4 portfolio-item isotope-item ${category}`}
                    >
                      <div className="portfolio-content h-100">
                        <img
                          src={imgSrc}
                          className="img-fluid"
                          alt={title}
                          loading="lazy"
                          decoding="async"
                        />
                        <div className="portfolio-info">
                          <a
                            href={imgSrc}
                            title={title}
                            data-gallery={gallery}
                            className={`glightbox preview-link ${gallery}`}
                            aria-label={title}
                          >
                            <BsZoomIn aria-hidden="true" />
                          </a>
                          <Link
                            to={detailsLink}
                            title="More Details"
                            aria-label="More Details"
                            className="details-link"
                          >
                            <BsLink45Deg aria-hidden="true" />
                          </Link>
                        </div>
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Uberuns;
